module.exports = __webpack_public_path__ + "environmental-science-and-forestry.png";